import image1 from '../images/memberships/Enmascarar grupo 7.png';
import image2 from '../images/memberships/Enmascarar grupo 6.png';

import first from '../images/memberships/first.png';
import diamond from '../images/memberships/diamond.png';

const memberships = [
	// {
	//     id: 0,
	//     image: image1,
	//     icon: first,
	//     title: "3 Pagos",
	//     price: "93",
	//     price_before: "166",
	//     items: [
	//         {
	//             item: "Acceso parcial a los entrenamientos.",
	//             more: "El contenido del máster de irá liberando por partes a medida que vayas pagando las cuotas.",
	//         },
	//         {
	//             item: "Acceso a feedback en vivo y materiales.",
	//             more: "Podrás acceder sin problema a los feedback en vivo y tendrás acompañamiento del maestro.",
	//         },
	//         {
	//             item: "Acceso por un año al contenido.",
	//             more: "El año de acceso se empieza a contar a partir de la activación del primer contenido. Te recomendamos revisar los términos y condiciones de financiación.",
	//         },
	//         { item: "Acceso a Discord Privado", more: null },
	//     ],
	//     urls: [
	//         {
	//             name: "Pagar con Paypal",
	//             url: "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=7T378UMQXAFGA",
	//         },
	//         {
	//             name: "Pagar con Tarjeta",
	//             url: " https://payco.link/1837210",
	//         },
	//     ]
	// },
	{
		id: 1,
		image: image2,
		icon: diamond,
		title: 'Único Pago',
		prices: [
			{
				price: '1.110.962 COP',
			},
			{
				price: '1.074 SOLES',
			},
			{
				price: '264 Euros',
			},
			{
				price: '256.458 ARS',
			},
			{
				price: '4.785 MXN',
			},
			{
				price: '279 USD',
			},
		],
		priceUSD: '279 USD',
		price_before: {
			CO: '1.565.932 COP',
			PE: '1.519 SOLES',
			EC: '399 USD',
			ES: '374 Euros',
			AR: '362.168 ARS',
			MX: '6.892 MXN',
			ALL: '399 USD',
		},
		items: [
			{
				item: 'Acceso a todos los entrenamientos',
				more: 'Tendrás a tu disposición todo el contenido del máster.',
			},
			{
				item: 'Acceso a feedback en vivo y materiales.',
				more: 'Podrás acceder sin problema a los feedback en vivo y tendrás acompañamiento del maestro.',
			},
			{
				item: 'Acceso por un año al contenido.',
				more: 'El año de acceso se empieza a contar a partir de la activación del contenido en tu cuenta..',
			},
			{ item: 'Acceso a Discord privado', more: null },
		],
		urls: [
			{
				name: 'Pagar con PayPal',
				url: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=6YXE45JTACAAN',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
			{
				name: 'Pagar con Tarjeta',
				url: 'https://checkout.wompi.co/l/wOMYt2',
				Viviana: 'https://wa.link/sarakb',
				Julian: 'https://wa.link/g32ron',
				Andres: 'https://wa.link/4vkv45',
			},
		],
	},
];

export default memberships;
